import * as React from "react";
import {DiscountCodePolicy,} from "@models/discountCodePolicy";
import {Table, Button, Divider, Modal} from "antd";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import {PaginationDefaultParams} from "../custom/Paginator";
import {getFormattedPrice} from "../../utils";
import __i18n from "../../intl/__i18n";
import {
  DiscountCodePolicyCalculationType,
  DiscountCodePolicyCalculationTypeOptions,
  DiscountCodePolicyTypeOptions,
  DiscountCodePolicyTypeOptionse
} from "../../models/discountCodePolicy";
import FormattedDateTime from '../custom/FormattedDateTime';
import {NavLink} from "react-router-dom";
import Message from "@constants/message";



type Props = {
  data: DiscountCodePolicy[];
  loading: boolean;
  deleteFn: (item: DiscountCodePolicy) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const TrackerPoliciesTable: React.FC<Props> = props => {
  const {data, loading, currentPage, deleteFn} = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const deleteItem = (item: DiscountCodePolicy): void => {
    Modal.confirm({
      content: __i18n(Message.Warning.Delete),
      okText: __i18n("Delete"),
      cancelText: __i18n("Cancel"),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item),
    });
  };
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      align:"right",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: __i18n("Title"),
      dataIndex: "title",
      key: "title",
      align:"right",
    },
    {
      title: __i18n("Type"),
      dataIndex: "type",
      key: "type",
      align:"center",
      render: (type, record) => DiscountCodePolicyTypeOptions.find(opt => opt.value === type)["label"]
    },
    {
      title: __i18n("Calculation Type"),
      dataIndex: "calculation_type",
      key: "calculation_type",
      align:"center",
      render: (calculation_type) => DiscountCodePolicyCalculationTypeOptions.find(opt => opt.value === calculation_type)["label"]
  
    },
    {
      title: __i18n("Discount Amount"),
      dataIndex: "amount",
      key: "amount",
      align:"center",
      render: (amount, record) => {
        if(record.calculation_type === DiscountCodePolicyCalculationType.Percentage){
          return `${amount} ${__i18n("Percent")}`
        }
        return getFormattedPrice(amount)
      }
    },
    {
      title: __i18n("Max Usage Count"),
      dataIndex: "max_usage_count",
      key: "max_usage_count",
      align:"center",
    },
    {
      title: __i18n("Max Value"),
      dataIndex: "max_value",
      key: "max_value",
      align:"center",
      render: (max_value) => getFormattedPrice(max_value)
    },
    {
      title: __i18n("Start Credit"),
      dataIndex: "valid_from",
      key: "valid_from",
      align:"center",
      render: (valid_from) => <FormattedDateTime showTime={false} date={valid_from} />
    },
    {
      title: (<FormattedMessage id="app.end_time" defaultMessage={`End Time`}/>),
      dataIndex: "valid_to",
      key: "valid_to",
      align:"center",
      render: (valid_to) => <FormattedDateTime showTime={false} date={valid_to} />
    },
    {
      title: '',
      key: 'actions',
      width: 110,
      dataIndex: 'actions',
      render: (text, record) => (
        <span>
          <NavLink to={`/discount-code-policies/${record.id}/edit`}>
            <Button type="link" size={`small`}>
             <FormattedMessage id="app.edit" defaultMessage={`Edit`}/>
           </Button>
          </NavLink>

          <Divider type="vertical" size={`small`}/>

          <Button size={"small"} type="link" className={`danger`} onClick={() => deleteItem(record)}>
            <FormattedMessage id="app.delete" defaultMessage={`Delete`}/>
          </Button>
        </span>
      ),
    },
  ];
  
  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(TrackerPoliciesTable);
